import React from "react"
import PropTypes from "prop-types"

import styles from "./pieTimer.module.scss"

const PieTimer = ({animDuration, isVisible}) => {
  let style = animDuration ? {animationDuration: animDuration} : {};
  return (
    <div className={styles.border}>
      <div style={style} className={styles.timer}>
        <div style={style}  className={styles.mask} />
      </div>
    </div>
  )
}

PieTimer.propTypes = {

}


export default PieTimer
